import { Platform, Dimensions } from "react-native"


const { width, height } = Dimensions.get('screen');

// TODO : get dimensions from theme shopify in mobile - can't import directly
const desktopDimensions = 1024;
const mediumWebDimensions = 1440;
const bigWebDimensions = 2560;


const isAndroid = Platform.OS === "android";

const isIos = Platform.OS === "ios";

const isWeb = Platform.OS === "web";

const isWebDesktop = isWeb && width >= desktopDimensions;

const isMediumWeb = isWebDesktop && width >= mediumWebDimensions;

const isBigWeb = isWebDesktop && width >= bigWebDimensions;

const isSmallWeb = isWeb && width >= desktopDimensions;


const isWebMobile = isWeb && !isWebDesktop;

export { isWeb, isSmallWeb, isWebDesktop, isMediumWeb, isBigWeb, isWebMobile, isAndroid, isIos };